import { IAdminState } from '@/@types'

const state: IAdminState = {
  isImpersonating: false,
  usersNewPassword: '',
}

export default state
